import { useEffect, useState } from 'react';

export const useClipboard = () => {
  const [text, setText] = useState('');

  useEffect(() => {
    setInterval(async () => {
      try {
        const text = await navigator.clipboard.readText();
        setText(text);
      } catch (e) { 
        // ignore
      }
    }, 200);
  }, []);

  return { text };
};